import { useMutation } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";

export const deleteImage = (url: string) => {
  return axios.put<string, AxiosResponse<string>, string>(
    "/storage/image/delete",
    JSON.stringify({ url }),
    {
      headers: { "Content-Type": "application/json" },
    },
  );
};

export const useDeleteImage = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: deleteImageFn,
  } = useMutation({
    mutationFn: deleteImage,
  });

  return { deleteImage: deleteImageFn, loading, error };
};
